<template>
<div>
  <div>
    <a-input-search placeholder="search" @search="onSearch" style="float:left;width:30%;margin:5px" />
    <a-button-group > 
          <a-button  @click="onSearch(lastMonthShort)" >{{lastMonth}}月</a-button>
          <a-button  @click="onSearch(currentMonthShort)" style="margin:5px">{{currentMonth}}月</a-button>
          <a-button  @click="onSearch('')">All</a-button>
    </a-button-group>
  </div>
  <a-table :loading="isLoading" :columns="columns" :dataSource="data" size="middle" :pagination="false" expandRowByClick :expandIconAsCell="false" :expandIconColumnIndex="-1">
    <span slot="status" slot-scope="status">
      <a-tag v-if="status==='confirmed'" color="green"><a-icon type="check"/></a-tag>
      <a-tag v-else-if="status==='rejected'" color="red"><a-icon type="close"/></a-tag>
      <a-tag v-else><a-icon type="question"/></a-tag>
    </span>

    <div slot="actions" slot-scope="text, record" style="margin: 0">
      <p>
      <a-popover title="承認しますか？" trigger="click" v-model="record.confirmpopvisible">
        <div slot="content">
          <a-button size="small" @click="onConfirmOKClicked(record)" type="danger" style="margin-left:5px">OK</a-button>
        </div>
        <!-- <a-button size="small" :disabled="record.disable" shape="circle" icon="check"></a-button> -->
        <a-button size="small" :disabled="record.disable">承認</a-button>
      </a-popover>
      </p>
      <p>
      <a-popover title="拒否しますか？" trigger="click" v-model="record.rejectpopvisible">
        <div slot="content">
          <a-input v-model="record.org.comment" placeholder="理由を入力ください" style="width:100%;text-align:left;margin-bottom:5px" />
          <a-button size="small" @click="onRejectOKClicked(record)" type="danger" style="margin-left:5px">OK</a-button>
        </div>
        <!-- <a-button size="small" :disabled="record.disable" type="danger" shape="circle" icon="close" style="margin-left:0"></a-button> -->
        <a-button size="small" :disabled="record.disable" type="danger">拒否</a-button>
      </a-popover>
      </p>
    </div>
    <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
      <!-- <a-card> -->
         <div style="margin-top:5px">
           <a-input :defaultValue="'No.'+record.org.employee.eid" disabled placeholder="未設定" style="width:28%;text-align:center" />
           <a-input :defaultValue="record.name" disabled placeholder="未設定" style="width:64%;text-align:center;margin-left:10px" />
         </div>

         <div style="margin-top:5px">
           <a-input :defaultValue="record.status_info" disabled placeholder="未設定" style="width:28%;text-align:center" />
           <a-input :defaultValue="record.org.comment" disabled placeholder="" style="width:64%;text-align:center;margin-left:10px" />
         </div>
        <a-range-picker style="margin-top:5px;width:95%" :defaultValue="[record.datefrom, record.dateto]" format="YYYY/MM/DD" disabled />
        <div style="margin-top:5px">
          <a-input :defaultValue="record.org.stationfrom" disabled placeholder="未設定" style="width:46%;text-align:center" />
          <span>～</span>
          <a-input :defaultValue="record.org.stationto" disabled placeholder="未設定" style="width:45%;text-align:center" />
        </div>
        <a-input-number :defaultValue="record.pricenumber" disabled style="margin-top:5px;width:95%" :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" :parser="value => value.replace(/\￥\s?|(,*)/g, '')" />
      <!-- </a-card> -->
    </div>
  </a-table>
</div>
</template>
<script>
const columns = [{
    title: '名前',
    dataIndex: 'name',
    key: 'name'
  },{
    title: '対象月',
    dataIndex: 'targmonth',
    key: 'targmonth'
  },
  {
    title: '対象年',
    dataIndex: 'targyear',
    key: 'targyear'
  },
  {
    title: '料金',
    dataIndex: 'price',
    key: 'price'
  },
  {
    title: '状態',
    dataIndex: 'status',
    key: 'status',
     scopedSlots: {
      customRender: 'status'
    }
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: {
      customRender: 'actions'
    }
  },
];
export default {
  name: "test",
  created() {
    let info = this.$store.getters.info
    if (info.permissions.filter(p => p.name === this.$permissions.update.te_status).length > 0) {
      this.disableActions = false
    }
    var today = new Date();
    this.lastMonth = today.getMonth()
    this.currentYear = today.getFullYear()
    this.currentMonth =  this.lastMonth+1
    if (this.lastMonth == 0){
      this.lastMonth = 12
      this.lastMonthShort = this.currentYear - 1 + "/" + this.lastMonth
    } else {
      if (this.lastMonth < 10) {
        this.lastMonthShort = this.currentYear + "/0" + this.lastMonth
      } else {
        this.lastMonthShort = this.currentYear + "/" + this.lastMonth
      }
    }
    if (this.currentMonth < 10) {
      this.currentMonthShort = this.currentYear + "/0" + this.currentMonth;
    } else {
      this.currentMonthShort = this.currentYear + "/" + this.currentMonth;
    }
    
    console.log("test:"+this.lastMonth);

    this.loadData()
  },
  computed: {
    data: {
      get: function() {
        this.tableData.sort((a,b)=>{
            if(a.sortkey!==b.sortkey){
              return b.sortkey-a.sortkey
            }else{
              return b.org.targmonth.replace("/","") - a.org.targmonth.replace("/","")
            }
        })
        if (this.filterword) {
          // return this.tableData.filter(d => (d.org.targmonth && d.org.targmonth.indexOf(this.filterword) !== -1));
          //return this.tableData.filter(d => (d.org.targmonth && d.org.targmonth.indexOf(this.filterword) !== -1) || (d.org.status && d.org.status.indexOf(this.filterword) !== -1) || d.status.indexOf(this.filterword) !== -1);
          return this.tableData.filter(d => ((d.org.targmonth && d.org.targmonth.indexOf(this.filterword) !== -1))||
                                              (d.org.targyear && d.org.targyear.indexOf(this.filterword) !== -1)||
                                              (d.name && d.name.indexOf(this.filterword) !== -1));
        } else {
          return this.tableData
        }
      }
    },
  },
  data() {
    return {
      isLoading: true,
      disableActions: true,
      filterword: "",
      tableData: [],
      columns,
      currentMonth:"",
      lastMonth:"",
      currentYear:"",
      lastMonthShort:"",
      currentMonthShort:""
    }
  },
  methods: {
    loadData() {
      this.isLoading = true
      let token = this.$store.getters.token;
      this.$api.transexp.query({
        token: token
      }).then(data => {
        let resp = data.data;
        this.isLoading = false;
        this.$logger.d("TransExpControl", "loadData.query", {
          response: resp
        });
        if (resp.error) {
          // this.$notification.error({
          //   message: "エラー:" + resp.error.code,
          //   description: resp.error.description
          // });
          // this.$router.push({
          //   path: "/"
          // });
          this.$error_handler(this,resp.error)
        } else {
          this.tableData = []
          resp.result.transexps.forEach((te, i) => {
            let s = (te.status === "comitted") ? "提出済" : (te.status === "confirmed") ? "承認済" : (te.status === "rejected") ? "拒否済" : "未設定";
            let sortkey = (te.status === "comitted") ? 2 : (te.status === "confirmed") ? 0 : (te.status === "rejected") ? 1 : 3;
            let disable = (this.disableActions || (te.status === "rejected" || te.status === "confirmed")) ? true : false
            let p = parseInt(te.price, 10)
            if (!p) p = 0
            if(te.employee){
              let name = te.employee.eid
              let userinfo =te.employee.user.userinfo
              if(userinfo){
                if(userinfo.lastname) name = userinfo.lastname+" "
                if(userinfo.firstname) name = name+userinfo.firstname
              }
              this.tableData.push({
                key: i,
                name:name,
                targmonth: te.targmonth,
                price: "¥"+te.price,
                status_info: s,
                status: te.status,
                sortkey:sortkey,
                disable: disable,
                datefrom: this.$moment(te.datefrom, 'YYYY/MM/DD'),
                dateto: this.$moment(te.dateto, 'YYYY/MM/DD'),
                pricenumber: p,
                confirmpopvisible: false,
                rejectpopvisible: false,
                org: te
              })
            }
          })
        }
      }).catch(err => {
        this.$logger.e("TransExpControl", "loadData.queryAll", {
          error: err
        });
        this.$notification.error({
          message: "エラー",
          description: "サーバ通信エラー"
        });
        this.$router.push({
          path: "/"
        });
      });
    },
    update(status,record){
      let token = this.$store.getters.token

      this.$api.transexp.update({
        eid: record.org.employee.eid,
        targmonth: record.org.targmonth,
        datefrom: record.org.datefrom,
        dateto: record.org.dateto,
        stationfrom: record.org.stationfrom,
        stationto: record.org.stationto,
        price: record.org.price,
        comment: record.org.comment,
        status: status,
        token: token
      }).then(data => {
        let resp = data.data;
        this.$logger.d("TransExpControl", "update", {
          response: resp
        });
        if (resp.error) {
          // this.$notification.error({
          //   message: "エラー:" + resp.error.code,
          //   description: resp.error.description
          // });
          this.$error_handler(this,resp.error)
        } else {
          this.loadData()
        }
      }).catch(err => {
        this.$logger.e("TransExpControl", "update", {
          error: err
        });
        this.$notification.error({
          message: "エラー",
          description: "サーバ通信エラー"
        });
      });
    },
    onSearch(value) {
      if(value == ''){
        this.filterword = ''
      }else{
        if(value < 10){
          this.filterword = '/0' + value
        }
        else if(value >=10 && value < 100){
          this.filterword = '/' + value
        } else {
          this.filterword = value;
        }
      }
    },
    onRejectOKClicked(record) {
      console.log(JSON.stringify(record.org));
      record.rejectpopvisible = false
      this.update("rejected",record)
    },
    onConfirmOKClicked(record) {
      record.rejectpopvisible = false
      this.update("confirmed",record)
    },
    onEditClicked(emp) {
      console.log(JSON.stringify(emp));
    }
  }
}
</script>
